import React from 'react';
import { Accordion } from './accordion';

export interface SignificanceProps {
  title: string;
  content: React.ReactNode;
  icon?: React.ReactNode;
}

export const SignificanceCard: React.FC<SignificanceProps> = ({
  content,
  title,
  icon,
}) => {
  return (
    <li className="w-full bg-white/90 backdrop-blur-sm rounded-xl shadow-sm border border-amber-200/50 overflow-hidden hover:shadow-md transition-shadow">
      <Accordion
        className="w-full font-display text-lg md:text-xl py-5 px-2"
        title={title}
        content={content}
        icon={icon}
      />
    </li>
  );
};
